import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";


export const fetchUserHomeOwnerDataApi = createAsyncThunk(
  "community/fetchUserHomeOwnerData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/home-owner/");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const createCommunityHomeOwnerApi = createAsyncThunk(
  "community/createNewCommunityapi",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/community/assign-user/", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);



export const fetchAllAssignHomeOwnerDataApi = createAsyncThunk(
  "community/ fetchAllAssignHomeOwner",
  async (Id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/assign-user/${Id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateHomeOwnerDataApi = createAsyncThunk(
  "community/ updateHomeOwnerDataApi",
  async ({ Id, community_id, board_member_id }, { rejectWithValue }) => {

    console.log("community_id", community_id, "board_member_id", board_member_id)
    
    try {
      const response = await axiosInstance.post(
        `/community/unassign-user/${Id}`,
        {},
        {
          params: {
            community_id: community_id,
            board_member_id: board_member_id
          }
        }
        
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const addMultipleHomeOwners = createAsyncThunk(
  "community/addMultipleHomeOwners",
  async ({ community_id, home_owners }, { rejectWithValue }) => {
    try {
      const payload = {
        community_id,
        home_owners,
      };

      // Send the JSON payload via POST request
      const response = await axiosInstance.post(
        "/community/add-multiple-home-owners/",
        payload
      );

      return response.data; // Handle successful response
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateHomeOwnerResidentAddress = createAsyncThunk(
  "community/updateHomeOwnerResidentAddress",
  async ({community_id, homeowner_id, temp_email_community_id, resident_address}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `/community/community-homeowner-resident-address/${community_id}/`,
        { 
          homeowner_id,
          temp_email_community_id,
          resident_address
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);